/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(".product__add-to-cart-button").click(function(){
        variant_max = parseInt($(".product-form__quantity-input").attr('data-max'));
        variant_min = parseInt($(".product-form__quantity-input").attr('data-min'));
        variant_qty = $(".product-form__quantity-input").val();
  console.log(variant_qty);
  console.log(variant_max);
  console.log(variant_min);
        if(variant_qty > variant_max || variant_qty < variant_min){
          if(variant_max==0){
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          } else if (variant_qty < 3) { 
            $(".quantity-limit-error").append("<span class=\"error-box\">Minimum quantity for orders is 3</span>");
          } else {
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          }
          return false;
        }	
 }); 

$(".shopify-payment-button__button").click(function(){
        variant_max = parseInt($(".product-form__quantity-input").attr('data-max'));
        variant_qty = $(".product-form__quantity-input").val();
  console.log(variant_qty);
  console.log(variant_max);
        if(variant_qty > variant_max){
          if(variant_max==0){
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          } else {
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          }
          return false;
        }
 }); 

$(".checkout-button").click(function(){
        variant_qty = $(".cart-item__qty-input").val();

        if(variant_qty > 50 || variant_qty < 1){
          if(variant_qty > 50){
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          } else if (variant_qty < 1) { 
            $(".quantity-limit-error").append("<span class=\"error-box\">Minimum quantity for orders is 3</span>");
          } else {
            $(".quantity-limit-error").append("<span class=\"error-box\">Please contact our sales team for orders greater than 50 units</span>");
          }
          return false;
        }	
 }); 
